export default __webpack_public_path__ + "static/media/Demi.bdea2330.svg";